import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dreamy%20artistic%20wide%20composition%20with%20warm%20golden%20amber%20and%20soft%20cream%20tones%2C%20floating%20geometric%20crystal%20shapes%20and%20delicate%20cherry%20blossom%20petals%2C%20ethereal%20light%20rays%20streaming%20diagonally%2C%20subtle%20bokeh%20particles%2C%20minimalist%20anime%20aesthetic%2C%20clean%20airy%20composition%20with%20ample%20negative%20space%2C%20editorial%20photography%20style%20with%20soft%20gradients&width=1800&height=900&seq=hero-bg-galgame-01&orientation=landscape"
          alt="Galgame资源大全 - 免费galgame资源下载与推荐合集"
          title="Galgame资源大全 · galgame资源下载"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/35"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center py-20">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-6 leading-tight">
          Galgame资源大全
        </h1>
        <p className="text-base md:text-lg text-white/85 max-w-2xl mx-auto mb-8 leading-relaxed">
          汇聚海量galgame资源下载、汉化补丁、推荐合集与新手入门指南
          <br className="hidden sm:block" />
          涵盖经典与新作，帮你快速找到心仪的galgame资源，告别搜索烦恼
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/story"
            className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-white font-medium rounded-full hover:bg-primary-600 transition-all duration-300 whitespace-nowrap text-sm"
          >
            开始探索
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/about"
            className="w-full sm:w-auto px-8 py-3.5 bg-white/15 backdrop-blur-sm text-white font-medium rounded-full hover:bg-white/25 transition-all duration-300 whitespace-nowrap text-sm border border-white/30"
          >
            了解更多
          </Link>
        </div>

        <div className="mt-12 flex flex-wrap items-center justify-center gap-8 text-white/70">
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-heading font-bold text-white">450+</div>
            <div className="text-xs mt-1">galgame资源收录</div>
          </div>
          <div className="w-px h-8 bg-white/20 hidden sm:block"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-heading font-bold text-white">6</div>
            <div className="text-xs mt-1">精选分类</div>
          </div>
          <div className="w-px h-8 bg-white/20 hidden sm:block"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-heading font-bold text-white">50+</div>
            <div className="text-xs mt-1">深度评测文章</div>
          </div>
        </div>
      </div>
    </section>
  );
}